import { PrognosePage } from "@/components/pg/prognose-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/prognose/")({
  component: PrognosePage,
});
